import * as React from "react";
import { connect } from "react-redux";
import { withRouter, Link } from 'react-router-dom';
import {get} from 'lodash';

import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import { formatPhoneNumber, getFirstName, firstNameFirst } from "../../helpers/formatting";

import StatusBanner from '../common/StatusBanner';

import StaticHtmlContent from "../common/staticHtmlContent";
import { queryParams } from "../../helpers/formatting";


const DATE_FORMAT = Tools.getDateFormats();

class CovidVaccineConfirmation extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.editAppt = this.editAppt.bind(this);
        this.formatTime = this.formatTime.bind(this);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.CovidVaccineConfirmation.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    editAppt(e, tryAgain) {
        // Needs to go back to Appointment Info step
        if (e) { e.preventDefault(); }

        //this.props.resetWizard();

        if (tryAgain) {
            this.props.tryAgain(0);
        }
    }

    editPatientInfo(e, tryAgain) {
        if (e) { e.preventDefault(); }

        if (tryAgain) {
            this.props.tryAgain(1);
        }
    }

    getDayOfWeek(x) {
        //var dt = new Date(x);
        var dt = Tools.toJSDate(`${x}T00:00:00`, DATE_FORMAT);

        var weekday = new Array(7);
        weekday[0] = "Sunday";
        weekday[1] = "Monday";
        weekday[2] = "Tuesday";
        weekday[3] = "Wednesday";
        weekday[4] = "Thursday";
        weekday[5] = "Friday";
        weekday[6] = "Saturday";
        if (Object.prototype.toString.call(dt) === '[object Date]') {
            var strDay = weekday[dt.getDay()];
            return strDay;
        }
        return "Invalid Date";
    }

    date2str(x) {
        var dt = Tools.toJSDate(`${x}T00:00:00`, DATE_FORMAT);

        try {
            const dayName = dt.getDate();
            let monthName = dt.getMonth() + 1;
            if (monthName < 10)
                monthName = "0" + monthName;

            return `${Tools.getMonthName(monthName.toString())} ${dayName}`;
        }
        catch { this.editAppt(""); }
    }

    dateFormatStrWithDayName(d) {
        if (!d) return '';
        let dateobj = Tools.getDateStrByFormat(Tools.toJSDate(`${d}T00:00:00`, DATE_FORMAT), "ddd MMM D, YYYY").toUpperCase();
        return dateobj;
    }

    formatTime(s) {
        let parts = s && s.split(":");
        let ret = s;

        if (parts && parts.length >= 2) {
            let h = parseInt(parts[0]);
            let m = parseInt(parts[1]);
            let s = parseInt(parts[2]);

            let ispm = h >= 12;
            h = h > 12 ? h - 12 : h;

            ret = `${h.toString()}:${m.toString().padStart(2, '0')} ${ispm ? "PM" : "AM"}`;
        }

        return ret;
    }

    render() {

        const { primaryUser, visit, serverData, covid19VaccineVisitTypeId, schedule, providerMessage, isFromSeeMore, covid19VaccineVisitTypeIdForMinor } = this.props;             
        const patientName = (visit.patient && visit.patient.name) ? visit.patient.name : (primaryUser && primaryUser.displayName ? primaryUser.displayName : "");       
        const providerPhone = visit && visit.department && visit.department.phone ? visit.department.phone : "";
        const locationName = visit && visit.department && visit.department.name ? visit.department.name : (schedule && schedule.department && schedule.department.name) ? schedule.department.name : "";
        let visitTypeDescription = visit.visitType.description.toLowerCase().indexOf("visit") >= 0 ?
            visit.visitType.description :
            visit.visitType.description + " Visit";
        const visitDirections = visit && visit.department.address ? 'https://www.google.com/maps/place/' + visit.department.address.street1 + ', ' + visit.department.address.city + ', ' + visit.department.address.state + ' ' + visit.department.address.zip : '#';
        const visitDirectionsTarget = visit && visit.department.address ? '_blank' : '_self';
        const videoVisitTypesForLaunchButton = serverData && serverData.videoVisitTypesForLaunchButton ? serverData.videoVisitTypesForLaunchButton : null;
        const isVirtualCareVisit = videoVisitTypesForLaunchButton ? videoVisitTypesForLaunchButton.indexOf(visit.visitType.id) >= 0 ? true : false : false;
        const iscovid19VaccineVisitType = visit && visit.visitType && (visit.visitType.id === covid19VaccineVisitTypeId || visit.visitType.id === covid19VaccineVisitTypeIdForMinor);
        const patientInstruction =  schedule && schedule.patientInstructions &&
            schedule.patientInstructions.length > 0;

        const covidVaccineDateStr = schedule && schedule.date ? this.date2str(schedule.date) : '';
        const covidVaccineTimeStr = schedule && schedule.time ? this.formatTime(schedule.time) : '';
        const covidVaccineDateWithDayName = schedule && schedule.date ? this.dateFormatStrWithDayName(schedule.date) : '';

        const visitDateTime = iscovid19VaccineVisitType ? (schedule && schedule.date && schedule.time ? new Date(`${schedule.date} ${schedule.time}`) : "") : new Date(`${visit.date} ${visit.time}`);
        
        const timezone = serverData && serverData.showTimeZoneMessage && !Tools.isCentralTimeZone() ? Tools.getCentralDateWithFormat(new Date(), "z") : "";
        const vaccineName = isFromSeeMore ? providerMessage : get(this.props, 'history.location.state.scheduleData.providerMessage');
        const vaccineMessage = vaccineName ? vaccineName.toLowerCase().indexOf('vaccine') > -1 ? vaccineName : (vaccineName + ' vaccine ') : 'appointment';

        return (
            <div className="schedule-confirmation-container covid-vaccine-confirmation" style={this.props.style}>
                <div className="row">
                    {(this.props.scheduleAppointmentSuccess === true && this.props.scheduleAppointmentFailed !== true) &&
                        <div className="col-12">
                            <StatusBanner
                                bannerMsg="Thanks, you’re all set! We look forward to seeing you."
                                bannerAlignment="left"
                                statusClass="covid-vaccine-success status-success"
                            >
                                <div className="covid-vaccine-subheading">
                                    <div>{`Your ${vaccineMessage} `} is scheduled for <span className="date-time">{covidVaccineTimeStr} on {covidVaccineDateWithDayName}.</span></div>
                                    <div className="email-confirmation">Email confirmation will be sent for this appointment.</div>
                                </div>
                            </StatusBanner>
                        </div>
                    }                    
                </div>
                <div className={"row" + (this.props.scheduleAppointmentFailed ? " schedule-failure" : "")}>
                    <div className="col-12 confirm-container maxWidth-content">
                        <div className="row">
                            <div className="col-12">
                                <div className="row confirm-appt-details-container">
                                    <div className="col-12 col-lg-6 col-xl-5">
                                        <div className="row confirm-doctor-addl-details">
                                            <div className="col-12 col-md-8 confirm-visit-info-container">
                                                <div className="visit-info">
                                                    {(!isVirtualCareVisit || this.props.scheduleAppointmentFailed) &&
                                                        <div className="confirm-visit-type"> {visitTypeDescription} </div>
                                                    }
                                                    <div className="item-details">                                                  
                                                        {(!isVirtualCareVisit || this.props.scheduleAppointmentFailed) && <div className="row">
                                                            <div className="col-12 item-location">
                                                                <a className={visit && visit.department.address ? "directions-link" : "no-link"} href={visitDirections} target={visitDirectionsTarget}>
                                                                    <div className="details-icon-prepend">
                                                                        <div className="icon-col">
                                                                            <span className="icon-address" />
                                                                        </div>
                                                                        <div className="details-col">
                                                                            {visit && visit.department.address && (visit.department.address.street1 || visit.department.address.city) ?
                                                                                <div>
                                                                                    {locationName && 
                                                                                        <div>{locationName}</div>
                                                                                    }
                                                                                    {visit.department.address.street1 || visit.department.address.street2 &&
                                                                                        <div>{visit.department.address.street1}{visit.department.address.street2 && <span>, {visit.department.address.street2},</span>} </div>
                                                                                    }
                                                                                    <div>{visit.department.address.city}, {visit.department.address.state} {visit.department.address.zip} </div>
                                                                                </div>
                                                                                : <div className="no-data-dash">
                                                                                    <div />
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        </div>}
                                                        <div className="row">
                                                            <div className="col-12 item-phone">
                                                                <a className={providerPhone ? "phone-link" : "no-link"} href={providerPhone ? "tel:" + (providerPhone) : "#"}>
                                                                    <div className="details-icon-prepend">
                                                                        <div className="icon-col">
                                                                            <span className="icon-phone" />
                                                                        </div>
                                                                        <div className="details-col">
                                                                            {providerPhone ?
                                                                                <div>{providerPhone}</div>
                                                                                : <div className="no-data-dash">
                                                                                    <div />
                                                                                </div>}
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="confirm-dr-details">
                                                    <div className="appt-schedule-for">
                                                        <div className="appt-heading"><span>Appointment Scheduled For:</span></div>
                                                        <div><span className="visit-time">{patientName}</span></div>                                                       
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4 text-end visit-date-container">
                                                <div>
                                                    <div className="visit-date">{covidVaccineDateStr}</div>
                                                    <div className="visit-time"><span>{covidVaccineTimeStr} {timezone}</span></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6 col-xl-7 covid-vaccine-confirm-addl-details">
                                        <div className="row confirm-doctor-addl-details">
                                            {(patientInstruction) &&
                                                <div className="col-12 covid-confirmation-container">
                                                    <div className="covid-visit-type">When You Arrive </div>
                                                    <ul className="schedule-patient-instructions">
                                                        {schedule.patientInstructions.map((item, index) => {
                                                            const listClass = item.indexOf("<br>- ") !== -1 ? "list-item-bullet" : "";
                                                            item = item.replace("<br>- ", "");
                                                            return item && <li className={listClass} key={index}><StaticHtmlContent content={item} customAllowedTags={['img']} customAllowedAttributes={{ 'img': ['src'] }} /></li>
                                                        })}
                                                    </ul>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>                    
                    <div className="col-12">
                        <div className="row">
                            <div className="col-12 maxWidth-content">
                                <div className="confirmation-status-container covid-confirmation">
                                    <div className="details-icon-prepend">
                                        <div className="icon-col">
                                            <span className="icon-echeck-in" />
                                        </div>
                                        <div className="details-col">
                                            Save some time before your visit! E-checkin will be available on your dashboard a few days prior to your visit.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>                   
                </div>    
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        schedule: state.openScheduling.schedule,        
        covid19VaccineVisitTypeId: state.session.serverData && state.session.serverData.covid19VaccineVisitTypeId,
        covid19VaccineVisitTypeIdForMinor: state.session.serverData && state.session.serverData.covid19VaccineVisitTypeIdForMinor
    };
};

export default withRouter(connect(mapStateToProps, null)(CovidVaccineConfirmation));